var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgView(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 15,
    viewBox: "0 0 19 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.7577 6.41254C18.188 6.9754 18.188 7.73527 17.7577 8.29722C16.4023 10.0666 13.1504 13.7098 9.35384 13.7098C5.55726 13.7098 2.30537 10.0666 0.949966 8.29722C0.740603 8.02771 0.626953 7.69616 0.626953 7.35488C0.626953 7.01361 0.740603 6.68205 0.949966 6.41254C2.30537 4.64316 5.55726 1 9.35384 1C13.1504 1 16.4023 4.64316 17.7577 6.41254V6.41254Z",
    stroke: "#8F96A5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.35438 10.0759C10.8585 10.0759 12.0779 8.85659 12.0779 7.35243C12.0779 5.84827 10.8585 4.62891 9.35438 4.62891C7.85022 4.62891 6.63086 5.84827 6.63086 7.35243C6.63086 8.85659 7.85022 10.0759 9.35438 10.0759Z",
    stroke: "#8F96A5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgView);
export default __webpack_public_path__ + "static/media/view.11aab83c29cf9db3fc5ece682927afc0.svg";
export { ForwardRef as ReactComponent };